export enum MarketingPageElementType {
  cardinteractive = 'card-interactive',
  videobutton = 'video-button',
  buttonprimary = 'button-primary',
  linkdropdown = 'link-dropdown',
  buttonsecondary = 'button-secondary',
  link = 'link',
  image = 'image',
  accordion = 'accordion'
}

export enum MarketingPageElementLocation {
  nav = 'nav',
  navsub = 'nav-sub',
  hero = 'hero',
  body = 'body',
  prefooter = 'prefooter',
  footer = 'footer'
}

// There are many more types in this enum, but they are used inside of the product
// we only need add marketing types here.
// Side note: the beacon event in the explorer is called "Modal Name"
// but within the code it is called "Modal Type"
export enum ModalName {
  bounceDetection = 'bounce detection'
}

export enum InteractedWithModalAction {
  clickedFinish = 'clicked finish',
  proceededToNextStage = 'proceeded to next stage',
  clickedOtherButton = 'clicked other button',
  proceededWithDemoFlow = 'proceeded with demo flow',
  clickedLink = 'clicked link',
  clickedCancel = 'clicked cancel',
  clickedSeeExample = 'clicked see example',
  clickedStartOver = 'clicked start over',
  clickedBack = 'clicked back',
  closedModal = 'closed modal',
  enteredEmail = 'entered email'
}
